import { Alert } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import { InspectionRequest } from '@/services/types/inspection.types';
import { InspectionItemStatus } from '@/shared/enums/InspectionStatus';
import { AutomaticLaudoStatus } from '@/features/laudo/components/AutomaticLaudoStatus';
import { AutomaticReportResponse } from '@/services/aiAnalysis.service';
import { LaudoTabHeader } from './LaudoTabHeader';

interface AutomaticLaudoSectionProps {
  inspection: InspectionRequest;
  itemId: string;
  itemStatus: InspectionItemStatus;
  onReportReady: (reportData: AutomaticReportResponse) => void;
  onRetry: () => void;
  onPdfGenerated: () => void;
  onRefresh?: () => void;
  onForceManual?: () => void;
  onCancelAutomatic?: () => void;
}
export function AutomaticLaudoSection({
  inspection,
  itemId,
  itemStatus,
  onReportReady,
  onRetry,
  onPdfGenerated,
  onRefresh,
  onForceManual,
  onCancelAutomatic,
}: AutomaticLaudoSectionProps) {
  return (
    <div className="space-y-6">
      <LaudoTabHeader isAutomaticAiReport={true} />

      <Alert
        type="info"
        message="Avaliação Automática"
        description="Esta inspeção utiliza Inteligência Artificial para gerar o laudo de avaliação automaticamente, sem necessidade de inspetor."
        showIcon
        icon={<RobotOutlined />}
        style={{ marginBottom: 16 }}
      />

      <AutomaticLaudoStatus
        inspectionItemId={itemId}
        itemStatus={itemStatus}
        inspection={inspection}
        onReportReady={onReportReady}
        onRetry={onRetry}
        onPdfGenerated={onPdfGenerated}
        onRefresh={onRefresh}
        {...(onForceManual && { onForceManual })}
        {...(onCancelAutomatic && { onCancelAutomatic })}
      />
    </div>
  );
}
